import CryptoJS from 'crypto-js';
export function concatUrlPath(requestUrl, requestPath) {
  if (!requestUrl) {
    return;
  }
  if (!requestPath) {
    return requestUrl;
  }

  let urlLastValue = requestUrl[requestPath.length - 1];
  let pathFirstValue = requestPath[0];

  const concatValue = '/';
  let resolutPath;
  if (concatValue !== urlLastValue && concatValue !== pathFirstValue) {
    resolutPath = requestUrl + '/' + requestPath;
  } else {
    resolutPath = requestUrl + requestPath;
  }

  return resolutPath;
}

export function encode(str) {
  return CryptoJS.MD5(str)
    .toString()
    .toLowerCase();
}
